module.exports = {"360112100":"长堎镇","360112101":"望城镇","360112102":"生米镇（红谷滩新区）","360112103":"西山镇","360112104":"石岗镇","360112105":"松湖镇","360112106":"樵舍镇","360112107":"乐化镇","360112108":"溪霞镇","360112109":"象山镇","360112110":"石埠镇","360112111":"联圩镇","360112112":"流湖镇","360112202":"厚田乡","360112204":"金桥乡","360112205":"铁河乡","360112206":"大塘坪乡","360112207":"昌邑乡","360112208":"南矶乡","360112400":"恒湖垦殖场","360112402":"成新实业有限公司","360112403":"朱港实业有限公司","360112404":"江西长堎外商投资工业区","360112450":"红角洲管理处（红谷滩新区）","360112451":"九龙湖管理处（红谷滩新区）","360112460":"江西桑海集团有限公司（南昌经济技术开发区）","360112461":"新祺周管理处（南昌经济技术开发区）","360112502":"新丰垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360112.json
// module id = 1251
// module chunks = 0